export interface RollingState { x: number; vx: number }
export interface RollingParams { gravity: number; drag: number; maxSpeed: number }

// Step the 1D rolling state forward by dtMs milliseconds.
//
// State is the ball's world x and horizontal velocity vx. The bar is implicit:
// callers pass the slope (sinTheta, cosTheta) and the x-bounds the ball cannot
// cross. Acceleration along the surface is gravity·sinTheta; we project to
// horizontal by multiplying by cosTheta. For small tilts this collapses to
// gravity·sinTheta — we keep the full form for correctness at any tilt.
//
// dtMs is substepped at 16ms-max to stay stable under long deltas (tab refocus).
export function stepRolling(
  state: RollingState,
  dtMs: number,
  sinTheta: number,
  cosTheta: number,
  xMin: number,
  xMax: number,
  params: RollingParams
): RollingState {
  let { x, vx } = state;
  let remaining = dtMs;
  while (remaining > 0) {
    const stepMs = Math.min(remaining, 16);
    const dt = stepMs / 1000;
    const ax = params.gravity * sinTheta * cosTheta - params.drag * vx;
    vx += ax * dt;
    if (vx > params.maxSpeed) vx = params.maxSpeed;
    else if (vx < -params.maxSpeed) vx = -params.maxSpeed;
    x += vx * dt;
    if (x <= xMin) { x = xMin; if (vx < 0) vx = 0; }
    else if (x >= xMax) { x = xMax; if (vx > 0) vx = 0; }
    remaining -= stepMs;
  }
  return { x, vx };
}

export function rollingToWorld(
  x: number,
  leftAnchorY: number,
  rightAnchorY: number,
  leftX: number,
  barLength: number,
  ballRadius: number,
  barThickness: number
): { x: number; y: number } {
  const t = (x - leftX) / barLength;
  const y = leftAnchorY + t * (rightAnchorY - leftAnchorY) - barThickness / 2 - ballRadius;
  return { x, y };
}
